// extracted by mini-css-extract-plugin
export default {"checkmark":"RV-rKyDRO9PjV2qTthuNNw=="};